import React, { useCallback } from 'react';

import { RefresherEventDetail } from '@ionic/core';
import { IonRefresher, IonRefresherContent } from '@ionic/react';

const Refresher = ({ onRefresh }: { onRefresh: () => void }) => {
  const doRefresh = useCallback(
    async (event: CustomEvent<RefresherEventDetail>) => {
      event.detail.complete();
      await onRefresh();
    },
    []
  );
  return (
    <IonRefresher slot={'fixed'} onIonRefresh={doRefresh}>
      <IonRefresherContent
        pullingIcon={'crescent'}
        refreshingSpinner={'crescent'}
      />
    </IonRefresher>
  );
};
export default Refresher;
